export enum CustomPropertyKey {
    FlowchartTemplateId = 'FlowchartTemplateId',
    TaskpaneMode = 'TaskpaneMode',
    RunConfigurationId = 'RunConfigurationId',
    FlowchartTemplatesVersionHistortyId = 'FlowchartTemplatesVersionHistortyId',
    Version = 'Version',
}
